import { schema } from 'normalizr';

export const ENTITY_VOICE_PLANS = 'voicePlans';

export const voicePlanSchema = new schema.Entity(ENTITY_VOICE_PLANS, {}, { idAttribute: () => 'data' });
